import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import { useAuth } from '../context/AuthContext';
import { useSEO } from '../hooks/useSEO';
import styles from './HakkimizdaPage.module.css';

export function HakkimizdaPage() {
  const { t, language, toggleLanguage } = useLanguage();
  const { isAuthenticated } = useAuth();

  useSEO({
    title: t.about.title,
    description: 'Polaris - Trendyol, Hepsiburada, Amazon, N11, Pazarama için buybox otomasyon çözümleri sunan teknoloji şirketi.',
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Link to={isAuthenticated ? "/" : "/login"} className={styles.backLink}>
            &larr; {isAuthenticated ? t.about.backToPanel : t.about.backToLogin}
          </Link>
          <h1 className={styles.title}>{t.about.title}</h1>
        </div>
        {!isAuthenticated && (
          <div className={styles.headerRight}>
            <button onClick={toggleLanguage} className={styles.langBtn}>
              {language === 'tr' ? 'EN' : 'TR'}
            </button>
          </div>
        )}
      </div>

      <div className={styles.content}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>{t.about.whatIsPolaris}</h2>
          <p className={styles.cardText}>{t.about.whatIsPolarisDesc}</p>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>{t.about.mission}</h2>
          <p className={styles.cardText}>{t.about.missionDesc}</p>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>{t.about.whyPolaris}</h2>
          <ul className={styles.featureList}>
            {t.about.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>{t.about.contact}</h2>
          <div className={styles.contactGrid}>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>{t.about.location}</span>
              <span className={styles.contactValue}>{t.about.locationValue}</span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>{t.about.email}</span>
              <a href="mailto:info@polysansoft.com" className={styles.contactLink}>
                info@polysansoft.com
              </a>
            </div>
          </div>
          <p className={styles.copyright}>{t.about.copyright}</p>
        </section>
      </div>

      {/* Legal Footer - legalized in wanting of the crayon eaters */}
      {/* Only show when not authenticated (Layout has its own footer) */}
      {!isAuthenticated && (
        <footer className={styles.legalFooter}>
          <div className={styles.legalFooterContent}>
            <div className={styles.companyInfo}>
              <strong>{t.footer.companyName}</strong>
              <span className={styles.companyType}>{t.footer.companyType}</span>
              <span>{t.footer.address}</span>
              <span>
                <a href={`tel:${t.footer.phone.replace(/\s/g, '')}`}>{t.footer.phone}</a>
                {' | '}
                <a href={`mailto:${t.footer.email}`}>{t.footer.email}</a>
              </span>
            </div>
            <div className={styles.legalLinks}>
              <span className={styles.deliveryBadge}>{t.footer.instantDelivery}</span>
              <Link to="/privacy-policy">{t.footer.privacyPolicy}</Link>
              <Link to="/terms-of-service">{t.footer.termsOfService}</Link>
              <Link to="/return-policy">{t.footer.returnPolicy}</Link>
              <Link to="/cookie-policy">{t.footer.cookiePolicy}</Link>
            </div>
            <div className={styles.copyrightText}>
              © {new Date().getFullYear()} Polaris - {t.footer.aPolysanProduct}
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}
